import { useQueryClient } from '@tanstack/react-query';
import {
	rosBusinessPersonQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import { is } from '@gov-nx/core/types';

export const useRosBusinessPersonQuery = () => {
	const queryClient = useQueryClient();
	const queryKey = ['profile-ros'];
	const { axiosInstance } = useAxiosInstance();
	const query = usePoQuery({
		queryKey,
		queryFn: () => rosBusinessPersonQuery(axiosInstance),
		retry: 1,
		refetchOnWindowFocus: false,
	});

	const rosContacts = query.data?.seznam?.filter(is) ?? [];

	return {
		...query,
		rosContacts,
		invalidate: async () => queryClient.invalidateQueries({ queryKey }),
	};
};
